/* eslint-disable jsx-a11y/aria-role */
import React from 'react';
import classNames from 'classnames';
/**
 * Bronson PriceBox component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-price-box.html
 * @desc Please note: In order to announce the discount value, discount price
 *       and actual price to assistive technology, apply both `[aria-label]` and
 *       `[role=text]` to those elements. This ensures accessible content without
 *       relying on the visual appearance.
 * @constructor
 */
export function PriceBox({ standalone, header, discountValue, ariaLabelDiscountValue, discountOldPrice, ariaLabelDiscountOldPrice, price, ariaLabelPrice, textAbovePrice, textBelowPrice, additionalInfo, testId, ...otherProps }) {
    const CustomTag = `${standalone ? 'article' : 'div'}`;
    const CustomTagHeader = `${standalone ? 'header' : 'div'}`;
    const classNameList = classNames('c-price-box ', { 'c-price-box--integrated ': !standalone }).trim();
    const tagClassNameList = classNames('c-tag ', 'c-tag--negative ', 'c-price-box__discount__value ').trim();
    function renderHeader() {
        if (header) {
            return React.createElement(CustomTagHeader, { className: "c-price-box__header" }, header);
        }
        return null;
    }
    function renderDiscountValue() {
        if (discountValue) {
            return (React.createElement("span", { className: tagClassNameList },
                React.createElement("span", { className: "c-tag__label", "aria-label": ariaLabelDiscountValue, role: "text" }, discountValue)));
        }
        return null;
    }
    function renderDiscountOldPrice() {
        if (discountOldPrice) {
            return (React.createElement("s", { className: "c-price-box__discount__old-price", "aria-label": ariaLabelDiscountOldPrice, role: "text" }, discountOldPrice));
        }
        return null;
    }
    function renderDiscount() {
        if (discountValue || discountOldPrice) {
            return (React.createElement("div", { className: "c-price-box__discount" },
                renderDiscountValue(),
                renderDiscountOldPrice()));
        }
        return null;
    }
    function renderPrice() {
        return (React.createElement("span", { className: "c-price-box__price", "aria-label": ariaLabelPrice, role: "text" }, price));
    }
    function renderTextAbovePrice() {
        if (textAbovePrice) {
            return React.createElement("span", { className: "c-price-box__text" }, textAbovePrice);
        }
        return null;
    }
    function renderTextBelowPrice() {
        if (textBelowPrice) {
            return React.createElement("span", { className: "c-price-box__text" }, textBelowPrice);
        }
        return null;
    }
    function renderAdditionalInfo() {
        if (additionalInfo) {
            return (React.createElement("div", { className: "c-price-box__additional-info" },
                React.createElement("p", { className: "c-price-box__additional-info__text" }, additionalInfo)));
        }
        return null;
    }
    return (React.createElement(CustomTag, { ...otherProps, "data-testid": testId, className: classNameList },
        renderHeader(),
        React.createElement("div", { className: "c-price-box__body" },
            React.createElement("div", { className: "c-price-box__body__content" },
                renderTextAbovePrice(),
                renderDiscount(),
                renderPrice(),
                renderTextBelowPrice()),
            renderAdditionalInfo())));
}
